import { GxIcon } from './icon.js'



export class GxIconCircleQuestion extends GxIcon {
  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10">
  </circle>
  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
  <path d="M12 17h.01"></path>
</svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-circlequestion")) window.customElements.define("gx-icon-circlequestion", GxIconCircleQuestion)
